import Vue from 'vue'
import {ptracGet, ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {crudifyMutations, hydrateEdit, resetResults, resetState} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'
import _ from 'lodash'

const initialState = {
  edit: {
    id: null,
    name: null,
    state: null,
    counties: [],
    zipCodes: [],
    fuelZone: null,
    timezone: null,
    active: true,
    serviceAreaId: null,
    distanceToServiceArea: 0,
  },
  results: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)

getters.putPayload = (state) => {
  return JSON.parse(JSON.stringify({
    id: state.edit.id,
    endpoint: 'cities',
    data: state.edit
  }))
}
getters.postPayload = (state) => {
  return JSON.parse(JSON.stringify({
    endpoint: 'cities',
    data: state.edit
  }))
}

const mutations = make.mutations(state)
mutations.reset = resetState
mutations.resetResults = resetResults
mutations.hydrateEdit = hydrateEdit
crudifyMutations(mutations)

mutations.resetEdit = (state) => {
  state.edit = {
    id: null,
    name: null,
    state: null,
    counties: [],
    zipCodes: [],
    timezone: null,
    active: true,
    serviceAreaId: null,
    distanceToServiceArea: 0
  }
}
mutations.resetResults = (state) => {
  state.results = []
}
mutations.deleteCity = (state, cityId) => {
  state.results = _.filter(state.results, (city) => city.id !== cityId)
}
mutations.addZipCode = (state, zipCode) => {
  state.edit.zipCodes.push(zipCode)
}
mutations.addCounty = (state, county) => {
  state.edit.counties.push(county)
}
mutations.deleteZipCode = (state, zipCodeToDelete) => {
  state.edit.zipCodes = _.filter(state.edit.zipCodes, (zipCode) => zipCode !== zipCodeToDelete)
}
mutations.deleteCounty = (state, countyToDelete) => {
  state.edit.counties = _.filter(state.edit.counties, (county) => county !== countyToDelete)
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchByName({ state }, name) {
      return await ptracGetEntities('cities/search/findOneByNameIgnoreCase?name=' + name)
    },
    async fetchTravelCharge({ state }) {
      return await ptracGet('travel-charge/by-city?cityId=' + state.edit.id)
    },
    async fetchTravelChargeParameters() {
      return await ptracGet('travel-charge/parameters')
    },
    async fetchByNameOrCountyOrZip({ state }, query) {
      const cleanQuery = encodeURIComponent(query)
      const url = 'cities/search/findByNameContainingIgnoreCaseOrCountiesIgnoreCaseOrZipCodesOrderByNameAsc' +
        '?name=' + cleanQuery +
        '&counties=' + cleanQuery +
        '&zipCodes=' + cleanQuery

      const response = await ptracGetEntities(url)

      if (OK === response.status) {
        state.results = response.data
      }

      return response
    }
  }
}
